import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "round",
})
export class RoundPipe implements PipeTransform {
  transform(value: number, direction: "default" | "up" | "down" = "default", places: number = 0): number {
    var func;
    switch (direction) {
      case "up":
        func = Math.ceil;
        break;
      case "down":
        func = Math.floor;
        break;
      default:
        func = Math.round;
        break;
    }
    return func(value * 10 ** places) / 10 ** places;
  }
}
